import cn from 'classnames';
import { useContext } from 'react';

import { BrandContext, HOME_CHEF, TEMPO } from 'context/BrandContext';
import useScreenSizeConstants from 'hooks/useScreenSizeConstants';

import FooterContent from './FooterContent';

const FooterContainer = () => {
  const { brand } = useContext(BrandContext);
  const { isAtLeastBp2 } = useScreenSizeConstants();

  const height = isAtLeastBp2 ? '140px' : '75px';

  return (
    <div
      className={cn('content-center', {
        'bg-cream-100': brand === HOME_CHEF,
        'bg-tempo-gray-40': brand === TEMPO,
      })}
      style={{ height }}
    >
      <FooterContent />
    </div>
  );
};

export default FooterContainer;
